import { createAction } from '@reduxjs/toolkit';

import type { AppState, SellTypes, GlobalTypes } from '@modules';
import api from '@modules/api';
import { createActions, createAsyncActions } from '@modules/helpers';

const actions = createActions('sell', {
  clearErrors: name => createAction<void>(name),
});

export const asyncActions = createAsyncActions('sell', {
  sellAction: (data: SellTypes.POSTSellParams, thunkApi) =>
    api.post<SellTypes.POSTSellResponse>(thunkApi, '/sell', { ...data, client: 'web' }),

  getSellStatus: (id: string, thunkApi) =>
    api.get<SellTypes.GETSellIdStatusResponse>(thunkApi, `/sell/${id}/status`),

  getSellRate: (data: Omit<SellTypes.GETSellRateParams, 'is_total'>, thunkApi) => {
    const state = thunkApi.getState() as AppState;
    const { crypto } = state.global.currencies;
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const is_total = crypto.includes(data.from as GlobalTypes.CryptoCurrencyEnum);
    const params = { ...data, is_total };
    return api.get<SellTypes.GETSellRateResponse>(thunkApi, '/sell/rate', { params });
  },
});

export default { ...actions, ...asyncActions };
